---
en:
  errors:
    messages:
      carrierwave_download_error: could not be downloaded
      carrierwave_integrity_error: is not of an allowed file type
      carrierwave_processing_error: failed to be processed
      content_type_blacklist_error: You are not allowed to upload %{content_type} files
      content_type_whitelist_error: 'You are not allowed to upload %{content_type} files, allowed types: %{allowed_types}'
      extension_blacklist_error: 'You are not allowed to upload %{extension} files, prohibited types: %{prohibited_types}'
      extension_whitelist_error: 'You are not allowed to upload %{extension} files, allowed types: %{allowed_types}'
      max_size_error: File size should be less than %{max_size}
      min_size_error: File size should be greater than %{min_size}
      mini_magick_processing_error: 'Failed to manipulate with MiniMagick, maybe it is not an image? Original Error: %{e}'
      rmagick_processing_error: Failed to manipulate with rmagick, maybe it is not an image?
